<template>
  <div class="item-wrapper">
    <input
      type="checkbox"
      class="item-wrapper__checkbox"
      v-if="item.id && isMassEdit"
      v-model="isChecked"
    />
    <router-link
      class="items-container__item item"
      :class="{ 'add-new-item': item.isNewRoute }"
      :to="item.isNewRoute ? { name: 'add-user' } : { name: 'user', params: {id: item.id}}"
    >
      <div class="item__row item__title">
        <span>{{ item.name }}</span>
        <span v-if="item.permitsCount || item.permitsCount === 0">
          <span class="item__subtitle">{{ $t('permits.permits') }}:&nbsp;</span>
          <span :class="[{'item__warning': item.isExistsFreePermits}]">{{ item.permitsCount }}</span>
        </span>
      </div>
      <div class="item__statusbar" v-if="!item.isNewRoute"></div>
      <div
        class="item__row item__subtitle"
        v-if="item.mobile"
      >{{ $t('common.phone') }}:&nbsp;{{ this.formatMobileNrForForm() }}</div>
    </router-link>
  </div>
</template>

<script>
import { format } from 'libphonenumber-js';

export default {
  props: {
    item: Object,
    isMassEdit: Boolean,
    onClickCheckbox: Function,
    checked: {
      type: Boolean,
      default: false,
    },
  },
  data() {
    return {
      isChecked: this.checked,
    };
  },
  methods: {
    formatMobileNrForForm() {
      return format({ country: this.item.mobileCountry, phone: this.item.mobile.toString() }, 'International_plaintext');
    },
  },
  watch: {
    isChecked() {
      this.onClickCheckbox(this.item.id, this.isChecked);
    },
  },
  updated() {
    this.isChecked = this.checked;
  },
};
</script>

<style lang="scss" scoped>
.permits-count {
  font-size: 16px;
}
</style>



// WEBPACK FOOTER //
// src/components/users/ListItemTemplate.vue